<template>
  <div class="animated fadeIn">
    <Row>
      <Input search @on-search="onFilterClick" size="small" v-model="keywordFilter" placeholder="关键字" style="width: 200px; margin-right: 3px;"></Input>
      <Button type="primary" style="margin-right: 10px;" size="small" @click="onFilterClick">查询</Button>
    </Row>
    <Row style="margin-top: 3px;">
      <div style="width: 100%;">
        <div style="position:relative;">
          <context-menu ref="contextMenuRef" :menuList="menuList" @callback="onContextMenuCallback"></context-menu>
          <Table border highlight-row size="small" height="600" :columns="columns" :stripe="true" :data="content" ref="table" :height="tableHeight"
                 @on-sort-change="sortChange" @on-filter-change="filterChange" @contextmenu.prevent.native="onTableRightClick($event)"></Table>
          <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="listLoadding">
            <Spin size="large"></Spin>
            <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
          </div>
        </div>
        <Page size="small" :total="totalElements" :page-size="pageSize" :current="pageIndex" :show-total="true" show-elevator @on-change="setPage"
              show-sizer @on-page-size-change="refreshPage" :page-size-opts="pagesizeopts"
              style="text-align:right;margin-top:3px;"></Page>

      </div>
    </Row>
    <business-note-detail-modal v-model="businessNoteDetailModal" :initValue="businessNoteInfo" :showBusinessState="false"
                                @on-success="onModifySuccess"></business-note-detail-modal>
    <client-info-detail-modal v-model="clientInfoDetailModal" :initValue="clientInfoDetailId"
                              @on-success="onModifySuccess"></client-info-detail-modal>
    <potential-detail-modal v-model="potentialVehicleInfoDetailModal" :initValue="potentialVehicleInfoDetailId"
                            @on-success="onModifySuccess"></potential-detail-modal>
    <combo-vehicle-info-detail-modal v-model="comboVehicleInfoDetailModal" :initValue="comboVehicleInfoDetailId"
                            @on-success="onModifySuccess"></combo-vehicle-info-detail-modal>
    <vehicle-info-detail-modal v-model="vehicleInfoDetailModal" :initValue="vehicleInfoDetailId"
                               @on-success="onModifySuccess"></vehicle-info-detail-modal>
    <web-table-columns-modal :columnList.sync="columns" :tableName="$options.name" v-model="webTableColumnsModal"></web-table-columns-modal>
  </div>
</template>

<script>

import BusinessNoteDetailModal from '@/view/crm/components/business-note-detail-modal'
import VehicleInfoDetailModal from '@/view/crm/components/vehicle-info-detail-modal'
import PotentialDetailModal from '@/view/crm/components/potential-detail-modal'
import ComboVehicleInfoDetailModal from '@/view/crm/components/combo-vehicle-info-detail-modal'
import ClientInfoDetailModal from '@/view/crm/components/client-info-detail-modal'

import Vue from 'vue'
import store from '@/store'
import { mapActions } from 'vuex'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
import { numberFormat } from '@/libs/numberutil'

export default {
  name: 'mybusinessnotes',
  components: {
    BusinessNoteDetailModal,
    VehicleInfoDetailModal,
    PotentialDetailModal,
    ClientInfoDetailModal,
    ComboVehicleInfoDetailModal
  },
  data () {
    return {

      webTableColumnsModal: false,
      menuList: [
        { title: '设置表格列', content: {} }
      ],

      totalElements: 0,
      content: [],
      pageSize: 0,

      colorLabelFilter: null,
      businessNoteTypeFilter: null,

      // 客户信息详细信息
      clientInfoDetailModal: false,
      clientInfoDetailId: null,

      // 潜在合拼车辆信息
      comboVehicleInfoDetailModal: false,
      comboVehicleInfoDetailId: null,

      // 潜在客户车辆详细信息
      potentialVehicleInfoDetailModal: false,
      potentialVehicleInfoDetailId: null,

      // 车辆信息详细信息
      vehicleInfoDetailModal: false,
      vehicleInfoDetailId: null,

      // 业务笔记详细信息
      businessNoteDetailModal: false,
      businessNoteDetailId: null,

      // 业务笔记
      businessNoteDetailModal: false,
      businessNoteInfo: {
        id: null,
        businessState: null,
        content: null,
        updateDatetime: null,
        clientInfoId: null,
        vehicleInfoId: null,
        potentialVehicleInfoId: null
      },

      pageFilter: 30,
      pagesizeopts:[30, 50,100,200],
      keywordFilter: null,
      tableHeight: 160,
      pageIndex: 1,
      sort: null,
      listLoadding: false,

      columns: [
        {
          title: 'ID',
          resizable: true,
          key: 'id',
          sortable: 'custom',
          tooltip: 'true',
          width: 70
        },
        {
          title: '标题',
          resizable: true,
          key: 'title',
          ellipsis: 'true',
          width: 200
        },
        {
          title: '笔记类型',
          resizable: true,
          ellipsis: 'true',
          width: 170,
          filters: [
            { label: '车辆信息', value: 1 },
            { label: '客户信息', value: 2 },
            // {label: '潜在客户车辆信息', value: 3},
            { label: '潜在合拼车辆信息', value: 4 }
          ],
          filterMultiple: false,
          filterRemote: (val) => {
            if (val.length > 0) {
              if (val[0] === 1) {
                this.businessNoteTypeFilter = genQueryParam('vehicleInfoId', 'NNULL', null)
              } else if (val[0] === 2) {
                this.businessNoteTypeFilter = genQueryParam('clientInfoId', 'NNULL', null)
              } else if (val[0] === 3) {
                this.businessNoteTypeFilter = genQueryParam('potentialVehicleInfoId', 'NNULL', null)
              } else if (val[0] === 4) {
                this.businessNoteTypeFilter = genQueryParam('comboVehicleInfoId', 'NNULL', null)
              } else {
                this.businessNoteTypeFilter = null
              }
            } else {
              this.businessNoteTypeFilter = null
            }
          },
          render: function (h, params) {
            if (params.row.vehicleInfoId) {
              return h('div', '车辆信息')
            } else if (params.row.clientInfoId) {
              return h('div', '客户信息')
            } else if (params.row.comboVehicleInfoId) {
              return h('div', '潜在合拼车辆信息')
            }
          }
        },
        {
          title: '颜色标签',
          resizable: true,
          key: 'colorLabel',
          ellipsis: 'true',
          width: 150,
          filters: [
            { label: '红色', value: 'ed4014' },
            { label: '橙色', value: 'ff9900' },
            { label: '黄色', value: 'ffff00' },
            { label: '绿色', value: '19be6b' },
            { label: '蓝色', value: '2db7f5' },
            { label: '紫色', value: '8a2be2' },
            { label: '无', value: 'NULL' }
          ],
          filterMultiple: true,
          filterRemote: (val) => {
            if (val.length > 0) {
              // if(val[0] === 'NULL'){
              //   this.colorLabelFilter = genQueryParam('colorLabel', 'EQNULL', null)
              // }else{
              //   this.colorLabelFilter = genQueryParam('colorLabel', 'LIKE', val[0])
              // }
              this.colorLabelFilter = []
              val.forEach(item => {
                this.colorLabelFilter.push(genQueryParam('colorLabel', 'LIKE', item))
              })
            } else {
              this.colorLabelFilter = null
            }
          },
          render: function (h, params) {
            if (params.row.colorLabel) {
              return h('div', {
                style: {
                  display: 'block',
                  width: '40px',
                  height: '20px',
                  backgroundColor: '#' + params.row.colorLabel
                }
              }, ' ')
            }
          }
        },
        {
          title: '笔记内容',
          resizable: true,
          ellipsis: 'true',
          tooltip: 'true',
          key: 'content',
          width: 270
        },
        {
          title: '最近修改时间',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'updateDatetime',
          width: 180,
          render: function (h, params) {
            if (params.row.updateDatetime) {
              let d = new Date(params.row.updateDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '创建时间',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'createDatetime',
          width: 200,
          render: function (h, params) {
            if (params.row.createDatetime) {
              let d = new Date(params.row.createDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '操作',
          key: 'action',
          align: 'left',
          ellipsis: 'true',
          minWidth: 200,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.businessNoteInfo.vehicleInfoId = params.row.vehicleInfoId
                    this.businessNoteInfo.clientInfoId = params.row.clientInfoId
                    this.businessNoteInfo.potentialVehicleInfoId = params.row.potentialVehicleInfoId
                    this.businessNoteInfo.id = params.row.id
                    this.businessNoteDetailId = params.row.id
                    this.businessNoteDetailModal = true
                  }
                }
              }, '详细信息'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    if (params.row.vehicleInfoId) {
                      this.vehicleInfoDetailId = params.row.vehicleInfoId
                      this.vehicleInfoDetailModal = true
                    } else if (params.row.clientInfoId) {
                      this.clientInfoDetailId = params.row.clientInfoId
                      this.clientInfoDetailModal = true
                    } else if (params.row.potentialVehicleInfoId) {
                      this.potentialVehicleInfoDetailId = params.row.potentialVehicleInfoId
                      this.potentialVehicleInfoDetailModal = true
                    } else if (params.row.comboVehicleInfoId) {
                      this.comboVehicleInfoDetailModal = true
                      this.comboVehicleInfoDetailId = params.row.comboVehicleInfoId
                    }
                  }
                }
              }, '查看关联资料')
            ])
          }
        }
      ]// cloumn
    }// return
  }, // data
  methods: {
    ...mapActions([
      'BusinessNoteServ_GetMyPage'
    ]),
    /**
       * 表格右键回调
       */
    onTableRightClick (e) {
      this.$refs.contextMenuRef.showMenu(e, this.$el, 0, -20)
    },
    /**
       * 右键菜单点击回调
       */
    onContextMenuCallback (item) {
      if (item.title === '设置表格列') {
        this.webTableColumnsModal = true
      }
    },
    onSuccess () {
      this.setPage(1)
    },
    onModifySuccess () {
      this.refreshPage(this.pageFilter)
    },
    onFilterClick () {
      this.setPage(1)
    },
    sortChange ({ column, key, order }) {
      this.sort = {
        name: key,
        asc: order === 'asc'
      }
      this.refreshPage(this.pageFilter)
    },
    filterChange () {
      this.refreshPage(this.pageFilter)
    },
    setPage (page) {
      console.log('setPage' + page)
      this.pageIndex = page
      this.listLoadding = true

      let queryParams = []
      let qo1 = null
      let sortParam = null

      if (this.sort) {
        sortParam = genSortParam(this.sort.name, this.sort.asc)
      }

      if (this.colorLabelFilter) {
        qo1 = this.colorLabelFilter
      }
      if (this.businessNoteTypeFilter) {
        queryParams.push(this.businessNoteTypeFilter)
      }

      store.dispatch('BusinessNoteServ_GetMyPage', {
        params: null,
        urlparams: {
          q: queryParams,
          qo1: qo1,
          ps: this.pageFilter,
          p: page,
          keyword: this.keywordFilter,
          sort: sortParam
        }
      }).then(() => {
        this.totalElements = store.getters.get_BusinessNote_GetMyPageResult.totalElements
        this.content = store.getters.get_BusinessNote_GetMyPageResult.content
        this.pageSize = store.getters.get_BusinessNote_GetMyPageResult.size
        this.listLoadding = false
      }).catch(err => {
        this.totalElements = 0
        this.content = []
        this.pageSize = 0
        this.listLoadding = false
        this.$Message.error(err)
      })
    },
    // 刷新当前页
    refreshPage (value) {
      this.pageFilter = value
      this.setPage(this.pageIndex)
    }
  },
  computed: {
    // totalElements() {
    //   if (store.getters.get_BusinessNote_GetMyPageResult) {
    //     return store.getters.get_BusinessNote_GetMyPageResult.totalElements
    //   } else {
    //     return 0
    //   }
    // },
    // content() {
    //   if (store.getters.get_BusinessNote_GetMyPageResult) {
    //     return store.getters.get_BusinessNote_GetMyPageResult.content
    //   } else {
    //     return []
    //   }
    // },
    // pageSize() {
    //   if (store.getters.get_BusinessNote_GetMyPageResult) {
    //     return store.getters.get_BusinessNote_GetMyPageResult.size
    //   } else {
    //     return 0
    //   }
    // }
  },
  mounted () {
    this.$nextTick(() => {
      this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      window.onresize = () => {
        this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      }
      this.setPage(1)
    })
  }
}
</script>

<style scoped>
</style>
